import { SITE_ICON_URL } from "@/constant";
import { QR_TYPES } from "@/constant/qr_type.enum";
import { QrTypeProps } from "./builder-qr.type";

export const DASHBOARD_STEP_TYPES: QrTypeProps[] = [
  {
    type_title: "Website", // dont change
    title: "URL", //dont change
    qr_type: QR_TYPES.URL,
    desc_title: "URL", // can be changed
    description: "Link to any web page",
    icon: `${SITE_ICON_URL}/url.svg`,
    customize: false,
    isFormData: false,
    isSignUp: false,
    isBulkCreate: true,
  },
  {
    type_title: "VCard",
    title: "VCard",
    qr_type: QR_TYPES.VCARD,
    desc_title: "VCard",
    description: "Share your contact details",
    icon: `${SITE_ICON_URL}/vcard.svg`,
    type: ["restaurant", "personal", "business", "doctor", "finance", "nonprofits", "government"],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Email",
    title: "Email",
    qr_type: QR_TYPES.EMAIL,
    desc_title: "Email",
    description: "Send and receive emails",
    icon: `${SITE_ICON_URL}/email.svg`,
    untracking: false,
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "Text",
    title: "Text",
    qr_type: QR_TYPES.TEXT,
    desc_title: "Text",
    description: "Share your stories, messages, opinions",
    icon: `${SITE_ICON_URL}/text.svg`,
    untracking: false,
    customize: false,
    isFormData: false,
    isSignUp: false,
    isBulkCreate: true,
  },
  {
    type_title: "PDF",
    title: "PDF",
    qr_type: QR_TYPES.PDF,
    desc_title: "PDF",
    description: "Share any PDF file with larger audiences",
    icon: `${SITE_ICON_URL}/pdf.svg`,
    type: [
      "tourism",
      "software",
      "products",
      "business",
      "finance",
      "cities",
      "home",
      "nonprofits",
    ],
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "Menu",
    title: "Menu",
    qr_type: QR_TYPES.MENU,
    desc_title: "Menu",
    description: "Enable contactless and eco-friendly menus",
    icon: `${SITE_ICON_URL}/menu.svg`,
    type: ["restaurant"],
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "Coupon",
    title: "Coupon",
    qr_type: QR_TYPES.COUPON,

    desc_title: "Coupon",
    description: "Deliver discounts and offers to your customers ",
    icon: `${SITE_ICON_URL}/coupon.svg`,
    type: ["event", "tourism", "gym", "publishers", "retail"],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Event",
    title: "Event",
    qr_type: QR_TYPES.EVENT,
    desc_title: "Event",
    description: "Promote your event easily",
    icon: `${SITE_ICON_URL}/event.svg`,
    type: ["event", "tourism", "education", "musician", "cities"],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "App",
    title: "App",
    qr_type: QR_TYPES.APP,
    desc_title: "App",
    description: "Redirect the target audience to your app on various App Stores",
    icon: `${SITE_ICON_URL}/app.svg`,
    type: ["software"],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Phone",
    title: "Call",
    qr_type: QR_TYPES.CALL,
    desc_title: "Phone",
    description: "Receive phone calls",
    icon: `${SITE_ICON_URL}/call.svg`,
    untracking: false,
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "SMS",
    title: "SMS",
    qr_type: QR_TYPES.SMS,
    desc_title: "SMS",
    description: "Send or receive text messages",
    icon: `${SITE_ICON_URL}/sms.svg`,
    untracking: false,
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "Location",
    title: "Location",
    qr_type: QR_TYPES.LOCATION,
    desc_title: "Location",
    description: "Show your location using an innovative way.",
    icon: `${SITE_ICON_URL}/location.svg`,
    type: ["restaurant", "tourism", "gym", "real"],
    customize: false,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Images",
    title: "Images",
    qr_type: QR_TYPES.IMAGES,
    desc_title: "Images",
    description: "Share your images faster ",
    icon: `${SITE_ICON_URL}/images.svg`,
    type: ["event", "personal", "hotel", "photographer", "real"],
    customize: true,
    isFormData: false,
    isSignUp: true,
    isBulkCreate: false,
  },
  {
    type_title: "Video",
    title: "Video",
    qr_type: QR_TYPES.VIDEO,
    desc_title: "Video",
    description: "Share one or more videos  ",
    icon: `${SITE_ICON_URL}/video.svg`,
    type: ["event", "software", "musician", "publishers"],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Business Page",
    title: "Business Page",
    qr_type: QR_TYPES.BUSINESSPAGE,
    desc_title: "Business Page",
    description: "Redirect your audience to your business page",
    icon: `${SITE_ICON_URL}/businesspage.svg`,
    type: [
      "event",
      "restaurant",
      "tourism",
      "software",
      "education",
      "business",
      "photographer",
      "real",
      "home",
      "government",
    ],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Social Media",
    title: "Social Media",
    qr_type: QR_TYPES.SOCIALMEDIA,
    desc_title: "Social Media",
    description: "Link to your social media accounts",
    icon: `${SITE_ICON_URL}/socialmedia.svg`,
    type: [
      "event",
      "restaurant",
      "personal",
      "tourism",
      "education",
      "business",
      "gym",
      "photographer",
      "musician",
      "retail",
    ],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Facebook",
    title: "Facebook",
    qr_type: QR_TYPES.FACEBOOK,
    desc_title: "Facebook",
    description: "Make your social media profile scanable and get more likes",
    icon: `${SITE_ICON_URL}/facebook.svg`,
    type: ["personal"],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "LinkedIn",
    title: "LinkedIn",
    qr_type: QR_TYPES.LINKEDIN,
    desc_title: "LinkedIn",
    description: "Link to your LinkedIn profile for effective networking",
    icon: `${SITE_ICON_URL}/linkedin.svg`,
    type: ["personal"],
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "MP3",
    title: "MP3",
    qr_type: QR_TYPES.MP3,
    desc_title: "MP3",
    description: "Maximize the sharing of your audio content ",
    icon: `${SITE_ICON_URL}/mp3.svg`,
    type: ["musician"],
    customize: true,
    isFormData: false,
    isSignUp: true,
  },
  {
    type_title: "Rating",
    title: "Rating",
    qr_type: QR_TYPES.RATING,

    desc_title: "Rating",
    description: "Get more customer reviews and boost your ratings ",
    icon: `${SITE_ICON_URL}/rating.svg`,
    type: ["restaurant", "tourism", "products"],
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "Feedback",
    title: "Feedback",
    qr_type: QR_TYPES.FEEDBACK,
    desc_title: "Feedback",
    description: "Collect feedback effortlessly ",
    icon: `${SITE_ICON_URL}/feedback.svg`,
    type: ["event", "software", "education", "hotel", "doctor"],
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "Crypto Wallet",
    title: "Crypto Wallet",
    qr_type: QR_TYPES.BITCOIN,
    desc_title: "Crypto Wallet",
    description: "Make your crypto transactions easier",
    icon: `${SITE_ICON_URL}/bitcoin.svg`,
    untracking: true,
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
  {
    type_title: "WiFi",
    title: "WiFi",
    qr_type: QR_TYPES.WIFI,
    desc_title: "WiFi",
    description: "Connect to the internet easily",
    icon: `${SITE_ICON_URL}/wifi.svg`,
    untracking: true,
    customize: false,
    isFormData: false,
    isSignUp: false,
  },
];
